// eslint-disable-next-line @typescript-eslint/no-explicit-any
const objectIsEmpty = (data: Record<string, any>) =>
  Object.entries(data).length === 0;

export default objectIsEmpty;
